import { ContextMenu, HoverActionButtonHierarchy, Menu, MenuPopover } from '@vizit/atoms';
import { cx } from '@vizit/theme';
import React from 'react';
import { AssetContext } from './asset.context-provider';
import { BUTTON_TOP_INSET } from './constants';

type AssetContextMenuProps = React.ComponentPropsWithoutRef<typeof Menu>;

function AssetContextMenu(props: AssetContextMenuProps) {
  const { children, className, ...other } = props;
  const { buttonTopOffset, isHovered, isFocused, isLoading, isViewOnly, onContextMenuMount, onHoverChange } =
    React.useContext(AssetContext);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const handleOpenChange = React.useCallback(
    (isOpen: boolean) => {
      setIsMenuOpen(isOpen);
      if (!isOpen) onHoverChange?.(false);
    },
    [onHoverChange],
  );

  React.useEffect(() => {
    if (isViewOnly) return;
    onContextMenuMount?.(true);

    return () => {
      onContextMenuMount?.(false);
    };
  }, [isViewOnly, onContextMenuMount]);

  if (isViewOnly) return null;

  return (
    <ContextMenu
      onOpenChange={handleOpenChange}
      triggerProps={{
        isHovered: isHovered || isFocused,
        isMenuOpen,
        isLoading,
        // Asset triggers always sit over imagery, so always the dark overlay
        // chip (explicit rather than relying on the atom's default).
        hierarchy: HoverActionButtonHierarchy.Secondary,
        className: cx('absolute right-1', className),
        style: { top: buttonTopOffset ?? `var(--asset-button-top, ${BUTTON_TOP_INSET}px)` },
      }}
    >
      <MenuPopover>
        <Menu {...other}>{children}</Menu>
      </MenuPopover>
    </ContextMenu>
  );
}

export { AssetContextMenu };
